import React, {
  useRef,
  useState,
  useEffect,
  useMemo,
  useCallback
} from "react";
import { postData } from "../common/utils";
import { decoratorArray } from "../common/decorator";
import { EditorState,  convertToRaw, convertFromRaw } from "draft-js";
import "draft-js/dist/Draft.css";
import { useParams, useHistory } from "react-router-dom";
import { encryptData } from "./../../utils/functions";


import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';

//Mention plugin
import Editor from "@draft-js-plugins/editor";
import "@draft-js-plugins/mention/lib/plugin.css";
import createMentionPlugin, {
  defaultSuggestionsFilter,
} from "@draft-js-plugins/mention";

//Export HTML plugin
import { stateToHTML } from "draft-js-export-html";

//React alert
import { useAlert } from "react-alert";

//Emoji
// import EmojiPicker from "./EmojiPicker";
// import Picker from 'emoji-picker-react';
import createEmojiPlugin from '@draft-js-plugins/emoji';
import '@draft-js-plugins/emoji/lib/plugin.css';

var mentions = [];

var badges = [];
//console.log(EditorState);
fetch(process.env.REACT_APP_API_URL + "api/posts/hashtag")
  .then((response) => response.json())
  .then((data) => {
    badges = data;
  });
const emojiPlugin = createEmojiPlugin({
  // selectGroups: [{
  //   title: 'Society',
  //   icon: '👥',
  //   categories: ['people', 'food', 'travel','nature'],
  // }, {
  //   title: 'Objects & symbols',
  //   icon: '❤️',
  //   categories: ['objects', 'symbols'],
  // }]
});
const { EmojiSuggestions, EmojiSelect } = emojiPlugin;

const EditPost = () => {
  const [disable, setDisable] = React.useState(false);
  const history = useHistory();
  const [editorState, setEditorState] = React.useState(() =>
    EditorState.createEmpty()
  );
  let { id } = useParams();
  const [postID, setPostID] = useState();
  const [oldPats, setOldPats] = useState(0);
  const [oldRecipient, setOldRecipient] = useState("");
  //var ContentState = convertFromRaw(data.postContent);
  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + "api/post/content/" + id)
      .then((response) => {
        //console.log("res: ",response);
        return response.json()
      }
      )
      .then((data) => {
        //debugger;
        //console.log("Success log json", convertFromRaw(JSON.parse(data.postContent)));
        //console.log("Success log 123", data.postContent);
        if (data.issuccessful == true) {
          setPostID(data.PID);
          setOldPats(data.postContent.PatsQuantity);
          setOldRecipient(data.postContent.RecipientID);
          //console.log(postID);
          setEditorState(
            EditorState.createWithContent(
              convertFromRaw(JSON.parse(data.postContent.PostJSON))
            )
          );
          //console.log("Success log json", JSON.parse(data.postContent));
        }
        //console.log("success", data);
      });
  }, []);


  const alert = useAlert();
  const ref = useRef(null);
  // const [editorState, setEditorState] = React.useState(() =>
  //   EditorState.createWithContent(
  //     convertFromRaw(JSON.parse(props.data.postJSON)),
  //     decorator
  //   )
  // );

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + "api/user/suggestions")
      .then((response) => response.json())
      .then((data) => (mentions = data));

  }, []);

  //#region Mention
  function mentionTest(props) {
    return (
      <span style={{ color: "#008bff", fontWeight: 600 }}>
        {props.decoratedText}
      </span>
    );
  }
  //Mention
  const [open, setOpen] = useState(false);

  const [suggestions, setSuggestions] = useState(mentions);

  const { MentionSuggestions, mentionPlugin } = useMemo(() => {
    const mentionPlugin = createMentionPlugin({
      mentionPrefix: "@",
      mentionTrigger: "@",
      mentionComponent: mentionTest,
    });
    const { MentionSuggestions } = mentionPlugin;
    return { mentionPlugin, MentionSuggestions };
  }, []);

  const onOpenChange = useCallback((_open) => {
    setOpen(_open);
  }, []);
  const onSearchChange = useCallback(({ value }) => {
    setSuggestions(defaultSuggestionsFilter(value, mentions));
  }, []);
  const onAddMention = () => {
    //alert('mention selected');
  };
  //#endregion

  //#region Badges
  function badgeTest(props) {
    return (
      <span className="testing" style={{ color: "#b4b4b4", fontWeight: 600 }}>
        {props.decoratedText}
      </span>
    );
  }
  const [open_badges, setOpen_badges] = useState(false);
  const [suggestions_badges, setSuggestions_badges] = useState(badges);
  const { BadgeSuggestions, mentionPlugin_badges } = useMemo(() => {
    const mentionPlugin_badges = createMentionPlugin({
      mentionPrefix: "#",
      mentionTrigger: "#",
      mentionComponent: badgeTest,
    });
    const { MentionSuggestions: BadgeSuggestions } = mentionPlugin_badges;
    return { mentionPlugin_badges, BadgeSuggestions };
  }, []);

  const onOpenChange_badges = useCallback((_open) => {
    setOpen_badges(_open);
  }, []);
  const onSearchChange_badges = useCallback(({ value }) => {
    setSuggestions_badges(defaultSuggestionsFilter(value, badges));
  }, []);
  const onAddMention_badges = () => {
    //alert('badge selected');
  };
  //#endregion

  //Editor Plugins
  const plugins = [mentionPlugin, mentionPlugin_badges, emojiPlugin];

  //#region Form Submit
  const updatePost = () => {
    var contentState = editorState.getCurrentContent();
    var postJSON = JSON.stringify(convertToRaw(contentState));
    var postString = contentState.getPlainText().trim();
    var postHTML = stateToHTML(contentState);
    var postid = postID;
    var oldpats = oldPats;
    var oldrecipients = oldRecipient;
    //All hashtags
    var allHashtags = postString.match(/[#]\w+/g);
    allHashtags =
      allHashtags == null
        ? []
        : allHashtags.map((element) => {
          return element.substring(1);
        });

    //Get mention count for validation. Only one recipient of pats allowed. Get id of first recipient
    //Get all suggested hashtags/badges. Remove them from allHashtags(Random hashtags that were not suggested)
    var entities = convertToRaw(contentState).entityMap;
    var mentionCount = 0;
    var recipientID = [];
    var suggestedHashtags = [];
    for (const entity in entities) {
      if (entities[entity].type == "mention") {
        mentionCount++;
        recipientID.push(entities[entity].data.mention.id);
        // if (mentionCount == 1) {
        //   recipientID = entities[entity].data.mention.id;
        //   console.log("recipientid", recipientID)
        // }
      } else if (entities[entity].type == "#mention") {
        suggestedHashtags.push(entities[entity].data.mention);
        //Remove suggestedHashtag from allHashtags
        allHashtags = allHashtags.filter((element) => {
          return element !== entities[entity].data.mention.name;
        });
      }
    }
    function refreshPage(data) {
      alert.success(data.message);
      setTimeout(() => {
        window.location.reload(false);
      }, 1000)
      history.push("/home");
    }

    //Get pats count for validation. +[0-9] is allowed only once
    var patsWithPlus = postString.match(/[+]\d+/g);
    var patsCount = patsWithPlus == null ? 0 : patsWithPlus.length;
    var pats =
      patsWithPlus == null ? 0 : parseInt(patsWithPlus[0].substring(1));

    // console.log("mentioncount",mentionCount);
    // console.log("pats",pats);
    // console.log(recipientID);

    const dividedPats = pats / mentionCount;

    const remainder = pats % mentionCount

    const hasDuplicates = (arr) => arr.length !== new Set(arr).size;

    //Check if post is empty
    if (postString !== "") {
      //Check if a person is mentioned - @
      if (mentionCount >= 1) {
        //Check if pats amount is given
        if (patsCount == 1) {
          var data = {
            recipientID: encryptData(recipientID),
            pats: encryptData(pats),
            dividedPats: encryptData(dividedPats),
            allHashtags: encryptData(allHashtags),
            suggestedHashtags: encryptData(suggestedHashtags),
            postJSON: encryptData(postJSON),
            postString: encryptData(postString),
            postHTML: encryptData(postHTML),
            postid: encryptData(postid),
            oldpats: encryptData(oldpats),
            oldrecipients: encryptData(oldrecipients),
          };
          if (pats >= 1 && remainder == 0) {
            if (hasDuplicates(recipientID)) {

              alert.error("Please tag user only once!");

            } else {

              postData(
                process.env.REACT_APP_API_URL + "api/posts/updatepost",
                data
              ).then((data) => {
                if (data.issuccessful == true) {
                  setDisable(true);
                  setEditorState(EditorState.createEmpty());
                  refreshPage(data);
                  history.push("/home");
                } else {
                  if (data.status == 400) {
                    alertify.alert('').setHeader('').setContent(data.message).set('label', 'Okay!').show();
                  } else {
                    alert.error(data.message);
                  }
                }
              });

            }

          } else {
            if (pats < 1) {
              alert.error("Pats cannot be less than 1");
            }
          }
        } else {
          if (patsCount > 1) {
            alert.error("Specify pats amount only once");
          } else if (patsCount < 1) {
            alert.error("Specify pats amount");
          }
        }
      }
      else {
        alert.error("Please mention atleast 1 person");
      }
    } else {
      alert.error("Empty Post!");
    }
  };

  //Emoji
  const [pickerOpen, togglePicker] = React.useReducer(state => !state, false);

  //#endregion

  return (
    <>
      <div className="pf-wrap">
        <div className="pf-tabs">
          <div className="pf-tab">
            <p>
              <span>+</span> Amount
            </p>
          </div>
          <div className="pf-tab">
            <p>
              <span>@</span> Recipient
            </p>
          </div>
          <div className="pf-tab">
            <p>
              <span>#</span> Badges
            </p>
          </div>
        </div>
        <div className="pf-form-wrap">
          <div className="pf-input-wrap">
            {/* <Editor editorState={editorState} onChange={setEditorState} /> */}
            <div
              className="pf-input"
              onClick={() => {
                ref.current.focus();
              }}
            >
              <Editor
                editorKey={"editor"}
                editorState={editorState}
                onChange={setEditorState}
                ref={ref}
                decorators={decoratorArray}
                plugins={plugins}
                className="editor-text"
              />
              <MentionSuggestions
                open={open}
                onOpenChange={onOpenChange}
                suggestions={suggestions}
                onSearchChange={onSearchChange}
                onAddMention={onAddMention}
              />
              <BadgeSuggestions
                open={open_badges}
                onOpenChange={onOpenChange_badges}
                suggestions={suggestions_badges}
                onSearchChange={onSearchChange_badges}
                onAddMention={onAddMention_badges}
              />


            </div>
            <EmojiSuggestions />
            <div //className={editorStyles.options}
            ><EmojiSelect
              // emojiInlineText
              />
            </div>
          </div>
          <div className="pf-btn-wrap">
            <div className="pf-round-wrap">
              {/* <div className="pf-round-item">
                  <img src={pf_group} style={{ width: '20px' }} alt="" />
                </div> */}
              {/* <div className="pf-round-item">
                  <img src={pf_tag} alt="" />
                </div>  */}
              {/* 
                <div className="pf-round-item pf-round-item-smile" onClick={togglePicker}>
                  {pickerOpen && <EmojiPicker setEditorState={setEditorState} cureditorState={editorState} />}
                  <img src={pf_smile} alt="" />
                </div>
    
                <div className="pf-round-item pf-round-item-gif">
                  <img src={pf_gif} alt="" />
                </div> */}

              {/* <div className="pf-round-item">
                  <img src={pf_image} alt="" />
                </div> */}
              {/* <div className="pf-round-item">
                  <img src={pf_link} alt="" />
                </div> */}
            </div>
            <div className="pf-give-wrap">
              <button className="blue-btn pf-btn" onClick={updatePost} disabled={disable}>
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditPost;
